import { render } from "./BlackList.vue?vue&type=template&id=5a2b57fc&scoped=true"
import script from "./BlackList.vue?vue&type=script&lang=js"
export * from "./BlackList.vue?vue&type=script&lang=js"

import "./BlackList.vue?vue&type=style&index=0&id=5a2b57fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a2b57fc"]])

export default __exports__